export const deviceTypes = [
  {
    label: "摄像头",
    value: 1,
    icon: require("@/assets/image/camera.png")
  },
  {
    label: "全景点位",
    value: 2,
    icon: require("@/assets/image/spot.png")
  },
  {
    label: "大屏",
    value: 3,
    icon: require("@/assets/image/screen.png")
  },
  {
    label: "Beacon",
    value: 4,
    icon: require("@/assets/image/beacon.png")
  }
];
